import { Type } from "class-transformer";
import "reflect-metadata";
import DisplayableCourse from "../interfaces/DisplayableCourse";
import HydraEntity from "./HydraEntity";

export class PunctualCourseDashboardUpdate extends HydraEntity implements DisplayableCourse {
    duration?: number | string;

    // @Type(() => Date)
    startDateTime?: Date;
    /**
     * The end datetime of the course.
     */
    // @Type(() => Date)
    endDateTime?: Date;
    // depositDate?: Date | string;
    // deposit?: number ;
    // proofDeposit?: number;
    chapter?: string;

    /** P1 – Séances détaillées d'un cours mensuel : [{date ISO, durationMinutes}]. */
    sessions?: Array<{ date: string; durationMinutes: number }> | null;

    /**
     * Déroulement propre à ce cours. Clé absente : inchangé ; null : retour à la
     * description habituelle du professeur ; texte : surcharge (30 à 1000 caractères).
     */
    sessionDescriptionOverride?: string | null;
    
    
    readonly id?: number;
    @Type(() => Date)
    readonly lastModificationDatetime?: Date;
    @Type(() => Date)
    readonly creationDatetime?: Date;
    readonly "@id"?: string;
    readonly "@type"?: string;
    readonly "@context"?: string;

    isNewDate?: boolean; // only used to display PunctualCourse in front, doesn't exist in db

    constructor(
        startDateTime: Date,
        endDateTime:Date,
        duration?: number | string,
    ) {
        super();
        this.startDateTime = startDateTime;
        this.endDateTime = endDateTime;
        this.duration = duration;
    }
}

export class PunctualCoursePassed extends HydraEntity implements DisplayableCourse {
  isPassedCourse: boolean;

  readonly id?: number;
  @Type(() => Date)
  readonly lastModificationDatetime?: Date;
  @Type(() => Date)
  readonly creationDatetime?: Date;
  readonly "@id"?: string;
  readonly "@type"?: string;
  readonly "@context"?: string;

  constructor(isPassedCourse: boolean) {
    super();
    this.isPassedCourse = isPassedCourse;
  }
}
